module.exports = __webpack_public_path__ + "img/logoAmeris.0827b626.jpg";